const GAP = 12
const MIN = 120


export default {
  data() {
    return {
      tableHeight: MIN,
      __tableAutoHeightTimer: null,
      __tableAutoHeightResizeHandler: null
    }
  },
  mounted() {
    this.__tableAutoHeightResizeHandler = () => {
      if (this.__tableAutoHeightTimer) clearTimeout(this.__tableAutoHeightTimer)
      this.__tableAutoHeightTimer = setTimeout(() => this.updateTableHeight(), 80)
    }
    window.addEventListener('resize', this.__tableAutoHeightResizeHandler)
    this.$nextTick(() => this.updateTableHeight())
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__tableAutoHeightResizeHandler)
    if (this.__tableAutoHeightTimer) clearTimeout(this.__tableAutoHeightTimer)
    this.__tableAutoHeightResizeHandler = null
    this.__tableAutoHeightTimer = null
  },
  methods: {
    updateTableHeight() {
      this.$nextTick(() => {
        const root = this.$refs.pageRoot
        if (!root) return

        const query = this.$refs.queryBar
        const pager = this.$refs.pagerBar

        const rootH = root.clientHeight || 0
        const queryH = query ? (query.offsetHeight || 0) : 0
        const pagerH = pager ? (pager.offsetHeight || 0) : 0

        let gaps = 0
        if (query) gaps += 1
        if (pager) gaps += 1

        const h = rootH - queryH - pagerH - gaps * GAP
        this.tableHeight = Math.max(MIN, Math.floor(h))
      })
    }
  }
}
